import styled from 'styled-components';

import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const BackLink = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;

  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: 20px;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.primary};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
`;

export const ContainerAvatar = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const StudentName = styled.h2`
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${colors.onSurface};

  span {
    color: ${colors.primary};
  }
`;

export const Subtitle = styled.p`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};
`;

export const Card = styled.div`
  padding: 28px;
  margin-bottom: 24px;
  border-radius: ${radius.md};
  background-color: ${colors.surfaceContainerLow};
`;

export const CardTitle = styled.h3`
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 20px;
`;

export const FieldsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const Field = styled.div`
  flex: 1;

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.onSurfaceVariant};
  }
`;

export const FieldInputGroup = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const FieldUnit = styled.span<{ side: 'left' | 'right' }>`
  position: absolute;
  ${props => (props.side === 'left' ? 'left: 16px;' : 'right: 16px;')}

  font-size: 14px;
  color: ${colors.onSurfaceVariant};
  pointer-events: none;
`;

export const FieldInput = styled.input<{ hasUnit?: 'left' | 'right' }>`
  width: 100%;
  padding: 14px 16px;
  ${props => props.hasUnit === 'left' && 'padding-left: 40px;'}
  ${props => props.hasUnit === 'right' && 'padding-right: 44px;'}
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant};
  background-color: ${colors.surface};
  color: ${colors.onSurface};
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${colors.primary};
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
  padding: 14px 24px;
  border-radius: ${radius.full};
  border: none;
  background-color: ${colors.primary};
  color: ${colors.onPrimary};
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  padding: 14px 24px;
  border-radius: ${radius.full};
  border: 1px solid ${colors.outlineVariant};
  background: transparent;
  color: ${colors.onSurface};
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;

  &:hover {
    border-color: ${colors.primary};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StatusBanner = styled.div<{ tone: 'ok' | 'overdue' | 'neutral' }>`
  display: inline-flex;
  padding: 6px 14px;
  margin-bottom: 20px;
  border-radius: ${radius.full};
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  background-color: ${props =>
    props.tone === 'ok'
      ? '#32a54a1a'
      : props.tone === 'overdue'
      ? `${colors.primary}1a`
      : colors.surfaceContainerHighest};
  color: ${props =>
    props.tone === 'ok'
      ? '#32a54a'
      : props.tone === 'overdue'
      ? colors.primary
      : colors.onSurfaceVariant};
`;

export const HistoryRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid ${colors.outlineVariant}30;
  font-size: 13px;

  &:last-child {
    border-bottom: none;
  }

  span:last-child {
    color: ${colors.onSurfaceVariant};
  }
`;

export const EmptyState = styled.div`
  padding: 20px 0;
  font-size: 13px;
  color: ${colors.onSurfaceVariant};
`;
